import React, { useLayoutEffect, useCallback, useState } from "react";

import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";

import { useLoading } from "../../../../shared/hooks/useLoading";

import { Contact } from "../../../../components/page-releated/consulta-previa/contact";
import { Header } from "../../../../components/page-releated/consulta-previa/header";
import { PropertiesApiService } from "../../../../shared/services/api/properties-api.service";
import {
    IProperty,
    IPropertyGeom,
} from "../../../../shared/interfaces/IProperties";
import { ILayers } from "../../../../shared/interfaces/ILayers";
import { LayersApiService } from "../../../../shared/services/api/layers-api.service";
import { ParkingLot } from "../../../../components/page-releated/consulta-previa/estacionamento";
import { GlobalStyle } from "../../../../components/page-releated/bci/header/styles";
import { UsoSolo } from "../../../../components/page-releated/consulta-previa/uso-solo/index";
import { Conclusion } from "../../../../components/page-releated/consulta-previa/conclusion";
import { Zoneamento } from "../../../../components/page-releated/consulta-previa/zoneamento";
import { DisclaimerAraucaria } from "../../../../components/page-releated/consulta-previa/disclaimer/araucaria";
import { AraucariaZonUso } from "../../../../components/page-releated/consulta-previa/zona-uso-ocupacao/araucaria";
import { Croqui } from "../../../../components/page-releated/bci/croquis/map";
import { CPFullMapContainer } from "../../../../components/page-releated/bci/croquis/styles";

export const AraucariaConsultaPrevia: React.FC = () => {
    const { setLoading } = useLoading();

    const { subscription } = useParams<{
        subscription: string | undefined;
    }>();

    const [property, setProperty] = useState<IProperty>();
    const [propertyGeom, setPropertyGeom] = useState<IPropertyGeom>();
    const [layers, setLayers] = useState<ILayers[]>();

    const fetchConsultaPrevia = useCallback(async () => {
        document.title = `CONSULTA PRÉVIA - ARAUCÁRIA - ${subscription}`;
        try {
            setLoading(true);

            if (subscription) {
                const {
                    property: propertyResponse,
                    geom: propertyGeomResponse,
                    // cnaes: cnaesResponse,
                } =
                    await PropertiesApiService.getPropertyConsultaPrevia(
                        subscription
                    );
                const layersResponse = await LayersApiService.getLayers(
                    `where={"cam_ativa_consultaprevia":"true"}&orderBy=ASC:cam_ordem&`
                );

                setProperty(propertyResponse);

                setPropertyGeom(propertyGeomResponse);

                setLayers(layersResponse.data);
            }
        } finally {
            setLoading(false);
        }
    }, [setLoading, subscription]);

    useLayoutEffect(() => {
        fetchConsultaPrevia();
    }, [fetchConsultaPrevia]);

    return (
        <Container>
            <GlobalStyle />
            <Header subscription={subscription || ""} />
            <DisclaimerAraucaria />
            <Zoneamento
                propertyInfo={property}
                propertyGeom={propertyGeom}
                layers={layers}
            />
            <div style={{ pageBreakBefore: "always" }} />
            <AraucariaZonUso propertyInfo={property} />
            <UsoSolo propertyInfo={property} />
            <div style={{ pageBreakBefore: "always" }} />
            <div style={{ pageBreakBefore: "always" }} />
            <ParkingLot />
            <div style={{ pageBreakBefore: "always" }} />
            <Contact />
            <Conclusion />
            {propertyGeom && layers && (
                <CPFullMapContainer>
                    <Croqui
                        layers={layers}
                        propertyGeom={propertyGeom}
                        padding={[45, 45, 45, 45]}
                    />
                </CPFullMapContainer>
            )}
        </Container>
    );
};
